import { CheckCircleTwoTone, ExclamationCircleTwoTone } from '@ant-design/icons';
import { Tooltip } from 'antd';

interface Props {
	tooltip?: string;
	status: 'OK' | 'NOK';
}

const ICONS = {
	OK: <CheckCircleTwoTone twoToneColor="#52c41a" />,
	NOK: <ExclamationCircleTwoTone twoToneColor="#b7b7b7" />,
};

const StatusIcon: React.FC<Props> = ({ status, tooltip }) => {
	if (tooltip) {
		return <Tooltip title={tooltip}>{ICONS[status]}</Tooltip>;
	}

	return ICONS[status];
};

export default StatusIcon;
